import { useState } from 'react';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

import ENGTRadio from 'components/UI/ENGTRadio/ENGTRadio';
import ModalAlert from 'components/UI/Modal/ModalAlert/ModalAlert';

import { IObjProps } from 'shared/consts/types';
import { CHANNELS } from 'shared/enum';

interface IRetargetPlatformSelectionModalProps {
	isModalOpen: Function;
	segmentData: IObjProps;
	onPlatformSelect: (platform: string, segmentData: IObjProps) => void;
}

const RetargetPlatformSelectionModal = ({
	isModalOpen,
	segmentData,
	onPlatformSelect,
}: IRetargetPlatformSelectionModalProps) => {
	const { t } = useTranslation(['common', 'pages']);
	const [css]: [any, any] = useStyletron();

	const [selectedPlatform, setSelectedPlatform] = useState<string>('');
	const [isDisabled, setIsDisabled] = useState<boolean>(true);

	const platformOptions = [
		{
			name: t('pages:broadcast.clickToWhatsappAds.whatsappRetarget'),
			value: CHANNELS.WHATSAPP,
		},
		{
			name: t('pages:broadcast.clickToWhatsappAds.instagramRetarget'),
			value: CHANNELS.INSTAGRAM,
		},
	];

	const onConfirm = () => {
		onPlatformSelect(selectedPlatform, segmentData);
		isModalOpen(false);
	};

	return (
		<ModalAlert
			closeBtnLabel={t('common:cancel')}
			confirmBtnLabel={t('common:next')}
			description={t('pages:broadcast.clickToWhatsappAds.selectPlatformDescription')}
			heading={t('pages:broadcast.clickToWhatsappAds.selectRetargetPlatform')}
			children={
				<div
					className={css({
						marginTop: '0.5rem',
					})}
				>
					<ENGTRadio
						group='platform'
						buttons={platformOptions}
						value={selectedPlatform}
						onChange={(value: string) => {
							setSelectedPlatform(value);
							setIsDisabled(false);
						}}
					/>
				</div>
			}
			isOpen
			width='25rem'
			height='30%'
			isConfirmBtnDisabled={isDisabled}
			onClose={() => {
				isModalOpen(false);
				setIsDisabled(true);
			}}
			closeable
			onConfirm={onConfirm}
			overrides={{
				ModalHeader: {
					marginTop: '1.75rem !important',
					marginBottom: '1rem',
				},
			}}
		/>
	);
};

export default RetargetPlatformSelectionModal;
